// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 320px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "(max-width: 1024px)";
var _5 = "card-28mtp";
var _6 = "segment-3MYe1";
var _7 = "canceled-22tiB";
var _8 = "title-2V8TW";
var _9 = "city-1GAaJ";
var _a = "transfer-3-6Qq";
var _b = "totalDuration-2dK7I";
var _c = "stopPointInfoMessage-1kcm1";
var _d = "stopPointInfoMessage__htmlMessage-EfifI";
var _e = "duration__wrapper-2KwQL";
var _f = "duration-1ZkL4";
var _10 = "duration__text-3nWMb";
var _11 = "stop-Q9V6u";
var _12 = "duration__point-JAdcv";
var _13 = "time-38Cxm";
var _14 = "time_dep-3lHva";
var _15 = "time_arr-3VXX2";
var _16 = "date-1Jfuc";
var _17 = "time__value-1Qubx";
var _18 = "flightNumber__route-28gWD";
var _19 = "transfer_stops-13ZAa";
var _1a = "transferCount-3CVk2";
var _1b = "row-1S6-_";
var _1c = "row_first-3A7gK";
var _1d = "row_last-3byXo";
var _1e = "row_time-qE0ED";
var _1f = "row_cities-3Nj-4";
var _20 = "icons-Pv0s6";
var _21 = "slide-2ZWhV";
var _22 = "flightNumber-zwGHX";
var _23 = "aircraftName-1jTxy";
var _24 = "aircraft-wuKum";
var _25 = "image-3_MTK";
var _26 = "image_return-22t22";
var _27 = "aircraft__details-XYZjc";
var _28 = "aircraft__name-rON9a";
var _29 = "aircraft__amenities-x_R_I";
var _2a = "modal-2zGJo";
var _2b = "aircraft__operatingCarrier-3wNUW";
export { _1 as "__esModule", _2 as "iphone5", _3 as "mobile", _4 as "tablet", _5 as "card", _6 as "segment", _7 as "canceled", _8 as "title", _9 as "city", _a as "transfer", _b as "totalDuration", _c as "stopPointInfoMessage", _d as "stopPointInfoMessage__htmlMessage", _e as "duration__wrapper", _f as "duration", _10 as "duration__text", _11 as "stop", _12 as "duration__point", _13 as "time", _14 as "time_dep", _15 as "time_arr", _16 as "date", _17 as "time__value", _18 as "flightNumber__route", _19 as "transfer_stops", _1a as "transferCount", _1b as "row", _1c as "row_first", _1d as "row_last", _1e as "row_time", _1f as "row_cities", _20 as "icons", _21 as "slide", _22 as "flightNumber", _23 as "aircraftName", _24 as "aircraft", _25 as "image", _26 as "image_return", _27 as "aircraft__details", _28 as "aircraft__name", _29 as "aircraft__amenities", _2a as "modal", _2b as "aircraft__operatingCarrier" }
export default { "__esModule": _1, "iphone5": _2, "mobile": _3, "tablet": _4, "card": _5, "segment": _6, "canceled": _7, "title": _8, "city": _9, "transfer": _a, "totalDuration": _b, "stopPointInfoMessage": _c, "stopPointInfoMessage__htmlMessage": _d, "duration__wrapper": _e, "duration": _f, "duration__text": _10, "stop": _11, "duration__point": _12, "time": _13, "time_dep": _14, "time_arr": _15, "date": _16, "time__value": _17, "flightNumber__route": _18, "transfer_stops": _19, "transferCount": _1a, "row": _1b, "row_first": _1c, "row_last": _1d, "row_time": _1e, "row_cities": _1f, "icons": _20, "slide": _21, "flightNumber": _22, "aircraftName": _23, "aircraft": _24, "image": _25, "image_return": _26, "aircraft__details": _27, "aircraft__name": _28, "aircraft__amenities": _29, "modal": _2a, "aircraft__operatingCarrier": _2b }
